import * as React from "react";
import {cs} from "@Common/react/chain-services";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload}      from "@fortawesome/free-solid-svg-icons";
import {Badge}           from "../../../../../common/design2/badge/badge";
import {chain}           from "../../../../../../../utils/fs";
import "./overview.scss";

export const Overview = ({fileName, cass}) => cs(
    ["downloadFailed", ({}, next) => next(cass.value?.data.failed && cass.value.data.failed.length > 0 && chain(
        cass.value.data.failed,
        data => ([
                [`"name"`, `"address"`, `"city"`, `"state"`, `"zip"`].join(","),
            data.map(d => (
                [`"${d.name}"`, `"${d.address}"`, `"${d.city}"`, `"${d.state}"`, `"${d.zip}"`].join(",")
            )).join("\n"),
        ].join("\n")),
        csv => new Blob([csv], {type: 'text/csv'}),
        blob => (
            <div className="download-space">
                <a
                    className="csv-download"
                    download={`${fileName.split('.').slice(0, -1).join('.')}_failed.csv`}
                    href={window.URL.createObjectURL(blob)}
                    xd-qa-type="link"
                    xd-qa-name="Download Failed"
                >
                    <div className="actions">
                        <button xd-qa-type="button" xd-qa-name="CASS Result View/Edit List">
                        <span>
                            <FontAwesomeIcon key={"download"} className="download-icon" icon={faDownload} xd-qa-type="icon" xd-qa-name="Download"/>
                        </span>
                            Download Failed Addresses
                        </button>
                    </div>
                </a>
            </div>
        )
    ))],
    ["downloadDuplicates", ({}, next) => next(cass.value?.data.duplicate && cass.value.data.duplicate.length > 0 && chain(
        cass.value.data.duplicate,
        data => ([
                [`"name"`, `"address"`, `"city"`, `"state"`, `"zip"`].join(","),
            data.map(d => (
                [`"${d.name}"`, `"${d.address}"`, `"${d.city}"`, `"${d.state}"`, `"${d.zip}"`].join(",")
            )).join("\n"),
        ].join("\n")),
        csv => new Blob([csv], {type: 'text/csv'}),
        blob => (
            <div className="download-space">
                <a
                    className="csv-download"
                    download={`${fileName.split('.').slice(0, -1).join('.')}_duplicates.csv`}
                    href={window.URL.createObjectURL(blob)}
                    xd-qa-type="link"
                    xd-qa-name="Download Duplicates"
                >
                    <div className="actions">
                        <button xd-qa-type="button" xd-qa-name="CASS Result View/Edit List">
                        <span>
                            <FontAwesomeIcon key={"download"} className="download-icon" icon={faDownload} xd-qa-type="icon" xd-qa-name="Download"/>
                        </span>
                            Download Duplicate Addresses
                        </button>
                    </div>
                </a>
            </div>
        )
    ))],
    ({downloadFailed, downloadDuplicates}) => (
        <div className="overview-a5jc">

            <div className="header">
                <div className="title">
                    <div className="label" xd-qa-type="label" xd-qa-name="CASS Result File Processed">
                        {cass?.loading ? (
                            "Processing File"
                        ) : (
                            "File Processed"
                        )}
                    </div>
                    <div className="file-name" xd-qa-type="label" xd-qa-name="CASS Result File Name">
                        {fileName}
                    </div>
                </div>

                <div className="sub-title" xd-qa-type="label" xd-qa-name="CASS Result File Processed Description">
                    {cass.value?.data.failed || cass.value?.data.duplicate ? (
                        "There are addresses that may require your attention. View results below."
                    ) : (
                        "All addresses are good"
                    )}
                </div>
            </div>

            <div className="box">
                <div className="status">
                    <div className="line">
                        {Badge({
                            color: "green",
                            text: cass.loading ? `Good --` : `Good ${cass.value?.data.success?.length > 0 ? cass.value?.data.success?.length : 0}`,
                            xdQaName: "CASS Result Good Count",
                        })}

                        {cass.value?.data.success?.length > 0 ? (
                            <div className="text" xd-qa-type="label" xd-qa-name="CASS Result Included">
                                Addresses successfully added to Do Not Mail list
                            </div>
                        ) : (
                            <div className="text" xd-qa-type="label" xd-qa-name="CASS Result Included">
                                No addresses added to Do Not Mail List
                            </div>
                        )}
                    </div>

                    {!!cass.value?.data.failed && (
                        <div className="line">
                            {Badge({
                                color: "red",
                                text: `Failed ${cass.value?.data.failed.length}`,
                                xdQaName: "CASS Result Failed Count",
                            })}

                            <div className="text" xd-qa-type="label" xd-qa-name="CASS Result Excluded">
                                You can download the failed addresses list to edit and resubmit
                            </div>

                            {downloadFailed}
                        </div>
                    )}

                    {!!cass.value?.data.duplicate && (
                        <div className="line">
                            {Badge({
                                color: "red",
                                text: `Duplicate ${cass.value?.data.duplicate.length}`,
                                xdQaName: "CASS Result Duplicate Count",
                            })}

                            <div className="text" xd-qa-type="label" xd-qa-name="CASS Result Excluded">
                                These addresses already exist in the Do Not Mail list. Download the duplicates to review.
                            </div>

                            {downloadDuplicates}
                        </div>
                    )}
                </div>
            </div>
        </div>
    ),
);